import { z } from 'zod';
import { objectId, timestampFields, FieldMetadata } from './base';
import { ConfigSchema } from './division';

/**
 * Tournament Schema
 * Represents a tournament within a league, can have multiple contests/seasons
 */

export const TournamentSchema = z.object({
  _id: objectId,
  name: z.string().optional(),
  priority: z.number().optional(),
  admins: z.array(objectId).default([]),
  config: ConfigSchema.optional(),
  sports: z.array(z.string()).default([]),
  startDate: z.coerce.date().optional(),
  active: z.boolean().default(true),
  // Refs
  // Top-level paymentProduct REMOVED (ADR 0034) — fee lives at config.paymentProduct.
  organization: objectId,
  ...timestampFields,
});

export type Tournament = z.infer<typeof TournamentSchema>;

// Metadata for Tournament fields (for Mongoose refs and UI)
export const tournamentMetadata: Record<string, FieldMetadata> = {
  _id: { hidden: true },
  name: { label: 'Tournament Name', editable: true },
  priority: { label: 'Priority', editable: true },
  sports: { label: 'Sports', editable: true },
  startDate: { label: 'Start Date', editable: true },
  active: { label: 'Active', editable: true },
  admins: { ref: 'Admin', label: 'Admins' },
  organization: { ref: 'Organization', hidden: true },
  created: { hidden: true },
  updated: { hidden: true },
};
